import { HomeyAPI } from 'homey-api';
import { useMemo } from 'react';
import semver from 'semver';

import { RouteManager } from '../../../RouteManager';

import { useI18n } from '../../../hooks/useI18nFormatters';
import { useApi } from '../../../store/SelectedHomeyStore.hooks.ts';
import { useUserMe } from '../../../store/users/useUserMe.ts';
import { useUser } from '../../../store/users/useUsers.ts';

import { glyph } from '../../../theme/glyph';
// import { DeveloperMenu } from '../../../components/common/context-menu/DeveloperMenu';

import { ContextMenuContent } from '../../../components/common/context-menu/ContextMenuContent';

export function FamilySettingsTableUsersContextMenuContent(props) {
  const { i18n } = useI18n();

  const { api, homey } = useApi();
  const { userMe } = useUserMe();
  const { user } = useUser({ userId: props.userId });

  const hasLocalUserFeature = useMemo(() => {
    const version = semver.coerce(homey?.softwareVersion);

    if (import.meta.env.MODE === 'self-hosted') {
      return true;
    }

    if (version == null) {
      return false;
    }

    const hasLocalUserFeatureVersion = semver.satisfies(version, '>=12.8.0');
    const hasLocalUserFeature =
      HomeyAPI.isHomeyAPIV3Local(api) === true && hasLocalUserFeatureVersion;

    return hasLocalUserFeature;
  }, [api, homey]);
  const isUserMeOrOwner = userMe?.id === user?.id || userMe?.role === 'owner';

  function onAction(key) {
    switch (key) {
      case 'transfer':
        // is a link
        break;
      case 'delete':
        // is a link
        break;
      case 'local-user':
        // is a link
        break;
      default:
        break;
    }
  }

  const isDeleteEnabled = (() => {
    // Prevent deleting the owner. Not possible with the API anyway.
    if (user?.role === 'owner') {
      return false;
    }

    // Allow deleting yourself.
    if (userMe?.id != null && user?.id != null && userMe?.id === user?.id) {
      return true;
    }

    // Owner can delete others.
    if (userMe?.role === 'owner') {
      return true;
    }

    return false;
  })();

  return (
    <ContextMenuContent.List style={{ '--context-menu-width': '300px' }}>
      {HomeyAPI.isHomeyAPIV3Cloud(api) === false &&
        userMe?.role === 'owner' &&
        user?.role !== 'owner' && (
          <ContextMenuContent.ListItem
            label={i18n.messageFormatter('settings.system.usersTransferOwnerButtonLabel')}
            icon={glyph.core.arrowDoubleSquare}
            to={RouteManager.getPathForSwapOwner(props.userId)}
            onPress={() => {
              onAction('transfer');
            }}
          />
        )}

      {isUserMeOrOwner && hasLocalUserFeature && user.localUsername == null && (
        <ContextMenuContent.ListItem
          label={i18n.messageFormatter('settings.system.usersEnableLocalUserButtonLabel')}
          icon={glyph.core.lock}
          to={
            import.meta.env.MODE === 'self-hosted'
              ? RouteManager.getPathForLocalUserUnsupported()
              : RouteManager.getPathForLocalUserEnable(props.userId)
          }
          onPress={() => {}}
        />
      )}

      {isUserMeOrOwner && hasLocalUserFeature && user.localUsername != null && (
        <ContextMenuContent.ListItem
          label={i18n.messageFormatter('settings.system.usersEditLocalUserButtonLabel')}
          icon={glyph.core.rectanglePen}
          to={
            import.meta.env.MODE === 'self-hosted'
              ? RouteManager.getPathForLocalUserUnsupported()
              : RouteManager.getPathForLocalUserEdit(props.userId)
          }
          onPress={() => {}}
        />
      )}

      {isUserMeOrOwner && hasLocalUserFeature && user.localUsername != null && (
        <ContextMenuContent.ListItem
          label={i18n.messageFormatter('settings.system.usersDisableLocalUserButtonLabel')}
          icon={glyph.core.lock}
          to={
            import.meta.env.MODE === 'self-hosted'
              ? RouteManager.getPathForLocalUserUnsupported()
              : RouteManager.getPathForLocalUserDisable(props.userId)
          }
          onPress={() => {}}
        />
      )}

      {/* <DeveloperMenu onIdRequest={() => user?.id} onResourceRequest={() => user} /> */}

      {HomeyAPI.isHomeyAPIV3Cloud(api) === false &&
        userMe?.role === 'owner' &&
        user?.role !== 'owner' && <ContextMenuContent.Divider />}

      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('common.delete')}
        variant="danger"
        icon={glyph.core.trashFill}
        to={RouteManager.getPathForDeleteUser(props.userId)}
        isDisabled={isDeleteEnabled === false}
        onPress={() => {
          onAction('delete');
        }}
      />
    </ContextMenuContent.List>
  );
}
